import one from '@mailobj-browser/front/js/selectors/one.js'
import { elements } from '../styles.js'
import { handleReset } from './wrapper.js'

const handler = (button, wrapper) => {
  const selectColor = one(`.${elements.new_field_select}`, wrapper)
  const inputColor = one(`.${elements.new_field_input}`, wrapper)
  const option = one('option', selectColor)
  const icon = one(`.${elements.icon}`, wrapper)

  option.value = ''
  option.textContent = 'transparent'
  icon.style.setProperty('--ea_icon_fill', 'transparent')
  selectColor.style.setProperty('--ea_pattern_color_color', 'transparent')
  inputColor.value = ''
}

export default button => {
  handleReset(button, handler)
}